const userDashboardData = { data: [], loading: true };
const userContractsData = { data: [], loading: true };
const userInstallmentsReports = { data: [], loading: true };
const userPaymentsReports = { data: [], loading: true };

export const GetUserDashboardData = (state = userDashboardData, action) => {
  switch (action.type) {
    case "get_userdashboard":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetUserContractsData = (state = userContractsData, action) => {
  switch (action.type) {
    case "get_usercontracts":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetUserInstallmentsReport = (state = userInstallmentsReports, action) => {
  switch (action.type) {
    case "get_userinstallmentsreport":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetUserPaymentsReport = (state = userPaymentsReports, action) => {
  switch (action.type) {
    case "get_userpaymentsreport":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
